<template>
    <div>

        <config-main-title>
            Recursos
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Recurso
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum recurso identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Recurso'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2" v-if="dado.st_sigla">{{ dado.st_sigla }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span v-if="dado.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in dado.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>
                            <button class="btn btn-outline-primary btn-sm ml-3" @click="abrir_anexos (dado)">
                                <i class="fa-solid fa-paperclip"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.arquivos && dado.arquivos.length">
                                    {{ dado.arquivos.length }}
                                </span>
                            </button>

                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_equipamento ) ? '' : 'Novo' }}
                            Recurso
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_equipamento">
                                #{{ item.id_equipamento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-10">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o nome do recurso..."
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_equipamento" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Sigla"
                                    type="text"
                                    :validate="validate"
                                    v-model="item.st_sigla" />
                            </div>
                        </div>

                        <az-sub-title class="mt-1" title="Classificação" />
                        <multiselect
                            v-model="item.js_classes"
                            :options="options_classes"
                            :multiple="true"
                            :taggable="true"
                            @tag="addTag"
                            placeholder="Selecione uma classificação..."
                            selectLabel="Pressione [ENTER] para selecionar"
                            deselectLabel="Pressione [ENTER] para remover"
                            tagPlaceholder="Pressione [ENTER] para incluir"
                            selectedLabel="Selecionado">
                            <template slot="noOptions">
                                Nenhuma classificação criada.
                            </template>
                        </multiselect>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    placeholder="Todas"
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div v-if="item.campos_customizados && item.campos_customizados.js_campos.length" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    v-model="item.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="equipamento" :id="item.id_equipamento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_equipamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="acao_anexar && item && item.arquivos">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos(false); load();"
                :tem_validade="true"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'equipamento', model_id: item.id_equipamento }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';

//import FiltroModel from '../shared/FiltroModel.vue';
//import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            options_classes: [], 
            acao_anexar: false, 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle, 
        Multiselect, 
        Formulario, 
        AzFileUpload, 
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        lista_models_leads: function () { 
            return [
                { id: 'App\\azure\\marcacao', search: 'Faltosos' },
                { id: 'App\\azure\\orcamento', search: 'Orçamentos' },
                { id: 'App\\azure\\requisicao', search: 'Requisição' },
                { id: 'App\\azure\\atendimentoProcedimento', search: 'Retorno Previsto' },
                { id: 'App\\azure\\retornoAtendimento', search: 'Retorno Programado' },
            ];
        }
    },

    methods: { 
        carregar_arquivos(abrir = false) {
            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.item.id_equipamento,
                    type: 'equipamento',
                }
            })
            .then(res => {
                this.item.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        abrir_anexos (item) {
            this.item = _.cloneDeep(item);
            this.acao_anexar = true;
            
            if ( item.arquivos && item.arquivos.length
                && !item.arquivos.find(arq => arq.arquivo) ) {

                this.carregar_arquivos(true);
                return;

            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_lead_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_equipamento: null,
                id_unidade: 1, 
                id_unidade_operacao: "", 
                st_equipamento: "", 
                st_sigla: "", 
                fl_ativo: true,
                st_observacoes: "", 
                js_classes: [],
                campos_customizados: null, 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'equipamentos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            if ( item.id_equipamento ) { 

                this.$util.loadItem(this, { 
                    service: 'equipamentos',
                    func: 'show',
                    parms: { 
                        id: item.id_equipamento,
                        cadastro: true, 
                    }
                })
                .then(res => { 
                    this.item = res;
                    $('#edicaoModal').modal('show');
                });

            } else { 

                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');

            }

        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'equipamentos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'equipamentos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Recursos", path: "/cadastros/equipamentos" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, {
            service: 'equipamentos',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style scoped>
.modal-dialog-alto {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>